import { Component, computed, effect, inject, NgZone, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NeogovTopNavbarElement } from '@neogov/top-navbar-definition';
import { AuthState } from './auth/application/states/auth.state';
import { NavBarProvider } from './core/providers/navbar/navbar.provider';
import { PlatformProvider } from './core/providers/platform/platform.provider';
import { RouteFocusService } from './core/providers/route-focus/route-focus.service';
import { SkeletonLoaderComponent } from './presentation/components/skeleton-loader/skeleton-loader.component';
import { SpinnerComponent } from './presentation/components/spinner/spinner.component';

declare global {
  interface HTMLElementTagNameMap {
    'ce-neogov-top-navbar': NeogovTopNavbarElement;
  }
}

@Component({
  selector: 'cm-root',
  imports: [RouterOutlet, SkeletonLoaderComponent, SpinnerComponent],
  templateUrl: './app.html',
  styleUrl: './app.less',
})
export class App implements OnInit {
  private readonly _ngZone = inject(NgZone);
  private readonly _navBarProvider = inject(NavBarProvider);
  private readonly _authState = inject(AuthState);
  private readonly _platform = inject(PlatformProvider);
  private readonly _routeFocus = inject(RouteFocusService);
  private _navbarInitialized = false;

  public readonly isLoadingNavigation = computed(() =>
    this._navBarProvider.isLoadingNavigation(),
  );

  /** Full-page "Closing session" overlay while logout/sign-out is in flight. */
  public readonly closingSession = computed(() => this._navBarProvider.closingSession());

  constructor() {
    this._routeFocus.initialize();

    effect(() => {
      const authed = this._authState.isAuthenticated();
      this._platform.toggleElementClass('ce-neogov-top-navbar', 'is-authenticated', authed);
      if (authed && !this._navbarInitialized) {
        this._navbarInitialized = true;
        this._navBarProvider.initialize(this._ngZone);
      }
    });
  }

  ngOnInit(): void {
    if (this._authState.isAuthenticated()) {
      this._navBarProvider.setLoadingNavigation(true);
    }
  }
}
